import type { StatCard } from "./dashboardData";
import type { DashboardStat } from "utils/dashboardApi";

export const primaryGradients = [
  "linear-gradient(135deg, #f87171, #fb7185)",
  "linear-gradient(135deg, #fbbf24, #f97316)",
  "linear-gradient(135deg, #38bdf8, #2563eb)",
  "linear-gradient(135deg, #34d399, #10b981)",
];

export const statGradientById: Record<string, string> = {
  atm_count: primaryGradients[0],
  todays_customers: primaryGradients[1],
  todays_dispense: primaryGradients[2],
  todays_recharge: primaryGradients[3],
};

const numberFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const decimalFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

function formatNumber(value: number) {
  if (Number.isInteger(value)) {
    return numberFormatter.format(value);
  }
  return decimalFormatter.format(value);
}

export function formatStatValue(value: number, unit?: string) {
  const formatted = formatNumber(value);

  if (!unit) {
    return formatted;
  }

  if (unit === "bdt") {
    return `BDT ${formatted}`;
  }

  if (unit === "litre") {
    return `${formatted} Ltr`;
  }

  return `${formatted} ${unit}`.trim();
}

export function mapStatsToCards(
  stats: DashboardStat[],
  translateLabel?: (stat: DashboardStat) => string
): StatCard[] {
  return stats.map((stat, index) => ({
    label: translateLabel ? translateLabel(stat) : stat.label,
    value: formatStatValue(stat.value, stat.unit),
    gradient:
      statGradientById[stat.id] ??
      primaryGradients[index % primaryGradients.length],
  }));
}

function extractPrimaryColor(gradient: string, fallback = "#2563eb") {
  const match = gradient.match(/#[0-9a-fA-F]{3,6}/);
  return match ? match[0] : fallback;
}

function hexToRgba(hex: string, alpha: number) {
  const sanitized = hex.replace("#", "");
  const bigint = parseInt(sanitized.length === 3 ? sanitized.repeat(2) : sanitized, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

const paletteColors = primaryGradients.map((gradient) =>
  extractPrimaryColor(gradient)
);

export const chartColorPalette = {
  newCards: {
    line: paletteColors[0],
    area: hexToRgba(paletteColors[0], 0.2),
  },
  waterDispense: {
    bar: paletteColors[2],
  },
  recharge: {
    bar: paletteColors[3],
  },
};
